import {
    getAdminCreateBlogMoudleFormHtml,
    getAdminUpdateBlogMoudleFormHtml,
    uploadBlogPostModuleImage,
    updateBlogPostModuleImage,
    getBlogPostModuleImage,
    submitBlogModuleForm,
    deleteBlogModule
} from "services/blogService";
import { injectHtml } from "utils/htmlUtil";
import forms from "components/common/forms"
import { openSnackbar, snackbarModel } from "components/common/snackbar";

const state = {
    activeModuleId: 0
}

const props = {
    adminBlogFormMarker: ".marker-blog-form",
    blogModuleModal: "#blog-module-modal",
    addModuleButton: ".fn-add-blog-module",
    editModuleButton: ".fn-edit-blog-module",
    deleteModuleButton: ".fn-delete-blog-module",
    submitModuleButton: "#submit-blog-post-module-form",
    moduleTypeDropDown: ".fn-select-blog-module-type",
    dynamicFieldsContainer: ".fn-dynamic-blog-module-fields",
    moduleForm: "#fn-blog-module-form",
    bindTinyMce: ".fn-bind-tinymce"
};

//! PUBLIC FUNCTIONS
export function initAdminBlogManagement() {
    if (!$(props.adminBlogFormMarker).length) return;

    bindFocusInBootstrapModalFix();
    bindAddBlogModule();
    bindEditBlogModule();
    bindDeleteBlogModule();
    bindSelectBlogModuleType();
    bindSubmitBlogModule();
    bindTinyMce();
}

//! PRIVATE BINDINGS
function bindFocusInBootstrapModalFix() {
    // Prevent Bootstrap modal from blocking focusin, without this some TinyMCE functionality is disabled such as 'Insert/edit link'
    // See TinyMCE docs for details: https://www.tiny.cloud/docs/integrations/bootstrap/#usingtinymceinabootstrapdialog
    $(document).on('focusin', function (e) {
        if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
            e.stopImmediatePropagation();
        }
    });
}

function bindAddBlogModule() {
    $(props.addModuleButton).click(function (e) {
        e.preventDefault();

        // Remove form fields from dom and show module type drop down as it's required for the create form
        $(props.dynamicFieldsContainer).empty();
        $(props.moduleTypeDropDown).show().val("");

        // Clear the active module id from state
        state.activeModuleId = 0;

        // Show the modal
        showBlogModuleModal();
    });
}

function bindEditBlogModule() {
    $(props.editModuleButton).click(async function (e) {
        e.preventDefault();

        // Remove form fields from dom and hide and reset module type drop down as it's not required for the edit form
        $(props.dynamicFieldsContainer).empty();
        $(props.moduleTypeDropDown).hide().val("");

        // Get the module id from data attribute
        const moduleId = $(this).data("module-id");

        // Set the active module id in state so it can be used later when submitting the edit form
        state.activeModuleId = moduleId;

        // Get the form html from server and inject into dom
        const data = await getAdminUpdateBlogMoudleFormHtml(moduleId || 0);
        await injectHtml(props.dynamicFieldsContainer, data);

        // Show the modal
        showBlogModuleModal();

        // Bind tiny mce if available
        bindTinyMce();
    });
}

function bindDeleteBlogModule() {
    $(props.deleteModuleButton).click(async function (e) {
        e.preventDefault();

        // Get the module id from data attribute
        const moduleId = $(this).data("module-id");

        // Get dom element for blog module
        const moduleDomElement = $(this).closest(".fn-blog-module-item");

        // Indicate the module is in the process of being removed 
        moduleDomElement.css("opacity", "0.5");

        // Call api to remove module
        const data = await deleteBlogModule(moduleId);

        // If the request failed, notify user with a snackbar and exit function
        if (data.responseType !== "SUCCESS") {
            moduleDomElement.css("opacity", "1");
            openSnackbar({
                ...snackbarModel,
                content: data.responseMessage,
                theme: "error"
            });
            return;
        }

        // If the module was successfully deleted, remove dom element for module
        // and notify user with a snackbar
        moduleDomElement.remove();

        openSnackbar({
            ...snackbarModel,
            content: data.responseMessage
        });
    });
}

function bindSelectBlogModuleType() {
    // Bind change event to the module drop down, depending on the module selected a different form
    // is returned from the server and injected into the dom.
    $(props.moduleTypeDropDown).change(async function () {
        const moduleTypeId = $(this).val();
        const data = await getAdminCreateBlogMoudleFormHtml(moduleTypeId);
        await injectHtml(props.dynamicFieldsContainer, data);
        bindTinyMce();
    });
}

function bindSubmitBlogModule() {

    const formObject = $(props.moduleForm);
    //forms.onloadValidationSetupByObject(formObject)

    $(props.submitModuleButton).click(async function (e) {
        e.preventDefault();

        const blogPostId = $(`${props.moduleForm} #BlogPostId`).val();

        //TODO: Handle module status
        //TODO: Handle module display order
        //TODO: Handle form validation (already have helper functions for jquery validation)
        //TODO: Add loading state on form submit / form rendering

        // First get the form data as a js object
        const rawFormValues = formObject.serializeArray();
        //console.log("RAW Submit Form", rawFormValues);

        // Get the module type id
        const moduleTypeId = rawFormValues.find(x => x.name === "ModuleTypeId");

        // Define our blacklist, these are fields that we don't want in our serialized module data that we store in the db.
        const blacklist = ["id", "ModuleTypeId", "BlogPostId", "__RequestVerificationToken", "Image.Alt"];

        // Next map this data into a cleaner format which matches our c# view model, any blacklisted fields
        // won't be returned in the final cleansed object
        const formValues = {};

        rawFormValues.forEach(x => {
            if (blacklist.includes(x.name)) return;
            formValues[x.name] = x.value;
        })

        // Handle image upload for modules with a selected image field
        const selectedImageField = $(`${props.moduleForm} #SelectedImage`);

        if (selectedImageField.length > 0) {
            const selectedImage = selectedImageField.prop('files');
            const imageAlt = rawFormValues.find(x => x.name === "Image.Alt");

            // If a file has been selected upload new image
            if (selectedImage.length > 0) {
                const uploadedImage = await uploadBlogPostModuleImage(selectedImage[0], blogPostId, imageAlt.value);
                // Add uploadedImage to formValues before it's converted to json
                formValues.Image = uploadedImage;
            } else {
                // Check to see if we already have an image mapped to this module
                const existingImageId = $(`${props.moduleForm} #Image_Id`).val();
                if (existingImageId) {
                    // If we already have an image get the image data from server and add to formValue
                    // this stops us loosing the image when out module content is serialized
                    const existingImage = await getBlogPostModuleImage(existingImageId);
                    formValues.Image = existingImage;
                }
            }

            // Save additional image details
            if (formValues.Image.id && formValues.Image.alt !== imageAlt.value) {
                await updateBlogPostModuleImage({ id: formValues.Image.id, alt: imageAlt.value });
            }

            // Update image alt tag
            formValues.Image.alt = imageAlt.value;
        }

        // Convert our cleansed object into json
        const moduleContent = JSON.stringify(formValues);

        // Build vm object and post to endpoint.
        const vm = {
            content: moduleContent,
            blogPostId: blogPostId || 0,
            id: state.activeModuleId || 0,
            moduleTypeId: moduleTypeId?.value || 0
        };

        const data = await submitBlogModuleForm(vm);

        //TODO: Handle fail message
        //TODO: Handle success message

        // Reload page
        location.reload();
    });
}

async function bindTinyMce() {
    // If no tinymce fields exit function
    if (!$(props.bindTinyMce).length) return;

    // Remove any bindings already initilised
    tinymce.remove(props.bindTinyMce);

    // Initilise the editor
    const editor = await tinymce.init({
        selector: props.bindTinyMce,
        plugins:
            'advlist anchor autolink charmap code codesample fullscreen image link lists paste searchreplace table help',
        toolbar:
            'bold italic underline forecolor | ' +
            'bullist numlist | fullscreen | ' +
            'table link codesample charmap | ' +
            'alignleft aligncenter alignright alignjustify ' +
            'help',
        menu: {
            file: {
                title: 'File',
                items: ''
            },
            edit: {
                title: 'Edit',
                items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
            },
            view: {
                title: 'View',
                items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
            },
            insert: {
                title: 'Insert',
                items: 'image link media addcomment pageembed template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
            },
            format: {
                title: 'Format',
                items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats align | forecolor | removeformat'
            },
            tools: {
                title: 'Tools',
                items: ''
            },
            table: {
                title: 'Table',
                items: 'inserttable | cell row column | advtablesort | tableprops deletetable'
            },
            help: {
                title: 'Help',
                items: 'help'
            }
        },
        force_p_newlines: false,
        forced_root_block: '',
        //For more styles use content_css (see the docs)
        content_style: "body { font-size: 14px; }",
        height: 480
    });

    // Loop through each editor and save changes when the content is updated
    editor.forEach(instance => instance.on("change keyup", () => instance.save()));


}

//! PRIVATE FUNCTIONS
function showBlogModuleModal() {
    $(props.blogModuleModal).modal("show");
}

function hideBlogModuleModal() {
    $(props.blogModuleModal).modal("hide");
}
